import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { uniqueId } from 'lodash'
import React, { FC, useState } from 'react'
import { secToHour, secToMinute } from '../../../utils/date'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import Tips from '../common/Tips'

interface List {
  id: number
  name: string | null
  profile_image?: string | null
  task_viewable?: boolean
  time: number
  cost: number
  color?: string
  approved?: boolean
  details: {
    id: number
    name: string | null
    profile_image?: string | null
    task_viewable?: boolean
    time: number
    cost: number
    color?: string
    approved?: boolean
  }[]
}

interface Props {
  list: List
  type: string
  costView: boolean
  clickDetailCallback?: (memberId: number, labelId: number) => void
  displayApprovalIcon?: boolean
  isProject?: boolean
  round?: boolean
}

const DetailRow: FC<Props> = (props) => {
  const {
    list,
    type,
    costView,
    clickDetailCallback,
    displayApprovalIcon,
    isProject,
    round,
  } = props

  const {
    login,
  } = useSelector((state: RootState) => state)

  const [isOpenDetail, setIsOpenDetail] = useState<boolean>(false)

  const clickDetail = (listId: number, detailId: number) => {
    if (!clickDetailCallback) return
    const memberId = type === "member" ? listId : detailId
    const labelId = type === "member" ? detailId : listId
    clickDetailCallback(memberId, labelId)
  }

  return (
    <>
      <div className="list_row_wrapper">
        <div
          className={`list_row${costView ? " cost_view" : ""}`}
          onClick={() => !!list.time && setIsOpenDetail(!isOpenDetail)}
          style={{ cursor: list.time ? "pointer" : "default" }}
          role="none"
        >
          <div className="title_display_area">
            <div className="text_area">
              {
                type === "label" && (
                  <div
                    className="icon"
                    style={{
                      backgroundColor: list.color,
                    }}
                  />
                )
              }
              {
                type === "label_group" && (
                  <div
                    style={{
                      backgroundColor: list.color,
                      width: "14px",
                      height: "14px",
                    }}
                  />
                )
              }
              {
                type === "label_code" && (
                  <div
                    style={{
                      color: list.color,
                    }}
                  >
                    <FontAwesomeIcon icon={['fas', 'star']} />
                  </div>
                )
              }
              {
                type === "member" && list.name && (
                  <>
                    {
                      list.profile_image ? (
                        <img
                          alt="profile"
                          src={list.profile_image}
                          className="icon"
                        />
                      ) : (
                        <img
                          alt="profile"
                          src={`/static/images/profile/${(Number(list.id) || 0) % 12}.jpeg`}
                          className="icon"
                        />
                      )
                    }
                  </>
                )
              }
              {
                list.name ? (
                  <>
                    {list.name}
                  </>
                ) : (
                  <span style={{ color: "#999999" }}>
                    削除済みユーザー
                  </span>
                )
              }
              {
                login.function_enabled_state?.task_management_approval
                && !!list.time
                && displayApprovalIcon
                && (
                  <>
                    <Tips
                      description={list.approved ? "すべてのデータが承認済みです" : "一部未承認のデータがあります"}
                      className=""
                      icon={false}
                      style={{
                        padding: 0,
                        width: "auto",
                      }}
                      key={uniqueId()}
                    >
                      <>
                        <div
                          style={{
                            backgroundColor: list.approved ? "#09984c" : "#FF0000",
                            borderRadius: "4px",
                            color: "#FFFFFF",
                            fontSize: "10px",
                            padding: "2px 4px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {list.approved ? "済" : "未"}
                        </div>
                      </>
                    </Tips>
                  </>
                )
              }
            </div>
            {
              !!list.time && (
                <button
                  type="button"
                >
                  詳細を見る
                  <FontAwesomeIcon icon={['fas', isOpenDetail ? 'angle-up' : 'angle-down']} />
                </button>
              )
            }
          </div>
          <div className="work_time">
            {
              Number(secToHour(list.time)) > 0
                ? (
                  <>
                    <span>
                      {secToHour(list.time)}
                    </span>
                    時間
                  </>
                )
                : ""
            }
            {
              Number(secToMinute(list.time)) > 0
                ? (
                  <>
                    <span>
                      {secToMinute(list.time)}
                    </span>
                    分
                  </>
                )
                : ""
            }
            {
              (list.time) < 60 && (list.time) > 0
                ? "1分未満"
                : ""
            }
            {
              (list.time) === 0
                ? "0分"
                : ""
            }
          </div>
          {
            costView && (
              <div className="work_cost">
                {`¥${list.cost.toLocaleString()}`}
              </div>
            )
          }
        </div>
        {
          isOpenDetail && (
            <div className="detail_row_wrapper">
              <div className="ruled_line">
                <div />
                <div />
              </div>
              {
                list.details.map((detail) => (
                  <div
                    key={uniqueId()}
                    className={`detail_row${costView ? " cost_view" : ""}`}
                  >
                    <div className="title_display_area">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        {
                          isProject ? (
                            <>
                              <div
                                className="icon"
                                style={{
                                  backgroundColor: detail.color,
                                  borderRadius: round ? "50%" : "0",
                                }}
                              />
                            </>
                          ) : (
                            <>
                              {
                                ["label_code", "member"].includes(type) && (
                                  <div
                                    className="icon"
                                    style={{
                                      backgroundColor: detail.color,
                                      borderRadius: round ? "50%" : "0",
                                    }}
                                  />
                                )
                              }
                              {
                                ["label", "label_group"].includes(type) && detail.name && (
                                  <>
                                    {
                                      detail.profile_image ? (
                                        <img
                                          alt="profile"
                                          src={detail.profile_image}
                                          className="icon"
                                        />
                                      ) : (
                                        <img
                                          alt="profile"
                                          src={`/static/images/profile/${(Number(detail.id) || 0) % 12}.jpeg`}
                                          className="icon"
                                        />
                                      )
                                    }
                                  </>
                                )
                              }
                            </>
                          )
                        }
                        {
                          detail.name ? (
                            <>
                              {detail.name}
                            </>
                          ) : (
                            <span style={{ color: "#999999" }}>
                              削除済みユーザー
                            </span>
                          )
                        }
                        {
                          login.function_enabled_state?.task_management_approval
                          && !!detail.time
                          && displayApprovalIcon
                          && (
                            <>
                              <Tips
                                description={detail.approved ? "すべてのデータが承認済みです" : "一部未承認のデータがあります"}
                                className=""
                                icon={false}
                                style={{
                                  padding: 0,
                                  width: "auto",
                                }}
                                key={uniqueId()}
                              >
                                <>
                                  <div
                                    style={{
                                      backgroundColor: detail.approved ? "#09984c" : "#FF0000",
                                      borderRadius: "4px",
                                      color: "#FFFFFF",
                                      fontSize: "10px",
                                      padding: "2px 4px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {detail.approved ? "済" : "未"}
                                  </div>
                                </>
                              </Tips>
                            </>
                          )
                        }
                      </div>
                      {
                        (
                          (type === "member" && list.task_viewable && (!!detail.time || !!detail.cost))
                          || (type === "label" && detail.task_viewable)
                        ) && (
                          <button
                            type="button"
                            onClick={() => clickDetail(list.id, detail.id)}
                            style={{
                              border: "1px solid #4372ba",
                              borderRadius: "20px",
                              fontSize: "12px",
                              padding: "4px 16px",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              wordBreak: "keep-all",
                            }}
                          >
                            詳細を見る
                            <FontAwesomeIcon icon={['fas', 'angle-down']} />
                          </button>
                        )
                      }
                    </div>
                    <div className="work_time">
                      {
                        Number(secToHour(detail.time)) > 0
                          ? (
                            <>
                              <span>
                                {secToHour(detail.time)}
                              </span>
                              時間
                            </>
                          )
                          : ""
                      }
                      {
                        Number(secToMinute(detail.time)) > 0
                          ? (
                            <>
                              <span>
                                {secToMinute(detail.time)}
                              </span>
                              分
                            </>
                          )
                          : ""
                      }
                      {
                        (detail.time) < 60 && (detail.time) > 0
                          ? "1分未満"
                          : ""
                      }
                      {
                        (detail.time) === 0
                          ? "0分"
                          : ""
                      }
                    </div>
                    {
                      costView && (
                        <div className="work_cost">
                          {`¥${detail.cost.toLocaleString()}`}
                        </div>
                      )
                    }
                  </div>
                ))
              }
            </div>
          )
        }
      </div>
    </>
  )
}

DetailRow.defaultProps = {
  displayApprovalIcon: false,
  clickDetailCallback: undefined,
  isProject: false,
  round: false,
}

export default DetailRow
